import {
  Grid,
  Link,
  Stack,
  TextField
} from "@mui/material";
import { StyledAction, StyledItem, StyledSpacer } from "../../../Provider/Provider.styles";
import Button from "components/shared/Button/Button";
import Session from "helpers/session";
import API from "api";import React, {useContext, useState} from "react";
import { AddEncounterEvent } from "../../../../helpers/variables";
import { useNavigate } from "react-router-dom";
import { RowInterface } from "../../../../context/initialState/Provider";
import {GlobalContext} from "../../../../context/Provider";
import { useEffect, ChangeEvent } from "react";

interface AssignmentProps {
  header: string;
  list: RowInterface[];
  type: "add" | "subtract";
  action: (event: any, type: string) => void;
}

interface ManageCoordsProps {
  type: "member" | "coordinator" | "archived";
  memberId: string;
}

const AssignmentList = (props: AssignmentProps) => {
  return (
    <div>
      <span>{props?.header}</span>
      {props?.list?.map((patient) => {
        return (
          <StyledItem key={patient?.id}>
            {patient?.name}
            <StyledAction
              id={patient?.id}
              onClick={(event: any) => {
                props?.action(event, props.type);
              }}
            >
              {props?.type === "add" ? "+" : "-"}
            </StyledAction>
          </StyledItem>
        );
      })}
    </div>
  );
};

export default function ManageCoords({
 type,
 memberId
}: ManageCoordsProps) {  const navigate = useNavigate();
  const [assignedList, setAssignedList] = useState<RowInterface[]>([]);
  const [availableList, setAvailableList] = useState<RowInterface[]>([]);
  const [showingAvailable, setShowingAvailable] = useState<RowInterface[]>([]);
  const [originalList, setOriginalList] = useState<string[]>([]);
  const [isDisabled, setDisabled] = useState<boolean>(true);
  let coordDictionary = {};
  const { member, memberDispatch, provider, encounterTimer } =
    useContext(GlobalContext);

  const handleShowingChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newShowing = availableList.filter((A) => {
      return A.name.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setShowingAvailable(newShowing);
  };
  const handleAddAll = () => {
    setAssignedList(availableList.concat(assignedList));
    setDisabled(false);
    setShowingAvailable([]);
  };
  const handleRemoveAll = () => {
    setAssignedList([]);
    setDisabled(false);
    setShowingAvailable(assignedList.concat(availableList));
  };
  const handleCoordinatorToggle = (event: any, action: string) => {
    // Maps client or member into correct dictionary
    if (type === "coordinator") {
      provider?.memberList.map((memb: RowInterface) => {
        // @ts-ignore
        coordDictionary[memb.id] = memb;
      });
    } else {
      provider?.coordinatorList.map((coord: RowInterface) => {
        // @ts-ignore
        coordDictionary[coord.id] = coord;
      });
    }
    setDisabled(false);
    const targetCoordinator = event.target.id;
    //Logic for add and subtract icons on client or member tiles. Moves them from avialable to assigned or vise versa.
    if (action === "add") {
      setAvailableList(
        availableList.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );
      setShowingAvailable(
        showingAvailable.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );
      setAssignedList(
        // @ts-ignore
        assignedList.concat([coordDictionary[targetCoordinator]])
      );
    } else {
      setAssignedList(
        assignedList.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );
      setAvailableList(
        // @ts-ignore
        availableList.concat([coordDictionary[targetCoordinator]])
      );
      setShowingAvailable(
        // @ts-ignore
        showingAvailable.concat([coordDictionary[targetCoordinator]])
      );
    }
  };

  const applyChanges = () => {
    if (type === "coordinator") {
      let newList = assignedList.map((A) => {
        return A.id;
      });
      API.kore.coordinator.updateAssociations(
        memberId,
        newList,
        Session.crackCookieToken("provider")
      )
      const encounterEvent = AddEncounterEvent(
        "profile change",
        "Profile updated"
      );
      const duration = encounterTimer?.current?.duration;
      // encounterDispatch({type: 'CHANGE_TARGET_ENCOUNTER', payload: encounters?.current.concat(encounterEvent)})
      Session.updateSessionEncounter(
        window.sessionStorage.getItem("encounter") || "",
        encounterEvent,
        duration?.toString() || ""
      );
      setDisabled(true);
      navigate(`/provider/coordinators`);
    } else {
      const sendList = assignedList.map((item) => {
        return item.id;
      });
      API.kore.members
        .updateAssociations(
          member?.current.id || "",
          sendList,
          Session.crackCookieToken("provider")
        )
        .then((update) => {
          memberDispatch({ type: "CHANGE_TARGET_MEMBER", payload: update });
          const encounterEvent = AddEncounterEvent(
            "profile change",
            "Profile updated"
          );
          const duration = encounterTimer?.current?.duration;
          // encounterDispatch({type: 'CHANGE_TARGET_ENCOUNTER', payload: encounters?.current.concat(encounterEvent)})
          Session.updateSessionEncounter(
            window.sessionStorage.getItem("encounter") || "",
            encounterEvent,
            duration?.toString() || ""
          );
          setDisabled(true);
        });
      navigate(`/provider/members`);
    }
  };

  useEffect(() => {
    if (!provider) return;

    const associationsCall =
      type === "coordinator"
        ? API.kore.coordinator.getAssociations(
          member?.current.id || "",
          Session.crackCookieToken("provider")
        )
        : API.kore.members.getAssociations(
          member?.current.id || "",
          Session.crackCookieToken("provider")
        );
    associationsCall.then((assignedIds: string[]) => {
      setOriginalList(assignedIds);

      const coordDictionary: Record<string, RowInterface> = {};
      const fullList = type === "coordinator" ? provider.memberList : provider.coordinatorList;
      fullList.forEach((item) => {
        coordDictionary[item.id] = item;
      });

      const fullAssigned = assignedIds.map((id) => coordDictionary[id]).filter(Boolean);

      const fullAvailable = fullList.filter((item) => !assignedIds.includes(item.id));

      setAssignedList(fullAssigned);
      setAvailableList(fullAvailable);
      setShowingAvailable(fullAvailable);
    });
  }, [type, member?.current.id, provider]);

  return(
    <div>
      <Grid container>
        <Grid item xs={9} />
        <Grid item xs={3}>
          <Stack direction={"row"} spacing={6}>
            <Link onClick={handleRemoveAll}>Remove All</Link>
            <Link onClick={handleAddAll}>Add All</Link>
          </Stack>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={2} />
        <Grid item xs={4}>
          <StyledSpacer />
          <Button
            width="90%"
            variant="primary"
            onClick={applyChanges}
            disabled={isDisabled}
          >
            Apply
          </Button>
          <StyledSpacer />
          <AssignmentList
            header="Currently Assigned"
            list={assignedList}
            action={handleCoordinatorToggle}
            type="subtract"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            placeholder="search"
            size="small"
            fullWidth
            onChange={handleShowingChange}
          />
          <AssignmentList
            header={`Available ${
              type === 'coordinator'? 'Members' : "Coordinators"
            }`}
            list={showingAvailable}
            action={handleCoordinatorToggle}
            type="add"
          />
        </Grid>
      </Grid>
    </div>
  );
}